import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=9c16c6b0&scoped=true&lang=pug&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=9c16c6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c16c6b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VItem,VItemGroup,VLayout})
